/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PrincipalRolesControllerCreateMutationRequest, PrincipalRolesControllerCreateMutationResponse, PrincipalRolesControllerCreate400, PrincipalRolesControllerCreate401, PrincipalRolesControllerCreate403 } from "../../models/principalRolesController/PrincipalRolesControllerCreate";

function getPrincipalRolesControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/principal-roles` as const }  
  return res
}

/**
 * @summary Assign a role to a principal
 * {@link /api/v1/principal-roles}
 */
export async function principalRolesControllerCreate(data?: PrincipalRolesControllerCreateMutationRequest, config: Partial<RequestConfig<PrincipalRolesControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PrincipalRolesControllerCreateMutationResponse, ResponseErrorConfig<PrincipalRolesControllerCreate400 | PrincipalRolesControllerCreate401 | PrincipalRolesControllerCreate403>, PrincipalRolesControllerCreateMutationRequest>({ method : "POST", url : getPrincipalRolesControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}